import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  AppVersionConfigEntity,
  AppVersionService,
  UpdateAppVersionConfigDto,
} from 'services/openapi';

import { AppVersionServiceKeys } from '../queries';

export const useUpdateAppVersionConfigMutation = () => {
  const queryClient = useQueryClient();

  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<AppVersionConfigEntity, Error, UpdateAppVersionConfigDto>({
      mutationFn: (variables: UpdateAppVersionConfigDto) =>
        AppVersionService.appVersionControllerUpdateAppVersionConfig(variables),
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [AppVersionServiceKeys.GET_APP_VERSION_CONFIG],
        });
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
